import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import DataTable, { DATA_TABLE_TYPES } from "../../components/Table/DataTable";
import ReportsService from "../../services/reports.service";
import { DATA_TABLE_FILTER } from "../../components/Table/FilterPopup";
import { DataLoading } from "../../components/PreLoader/PreLoader";
import { Amount } from "../../components/General/Amount";
import PlansService from "../../services/plan.service";
import moment from "jalali-moment";

const PaymentStats = ({}) => {
    const {t} = useTranslation();
    const {setPageTitle} = useOutletContext();
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    let defaultFilterConfig = {
        date: {
            type: "range",
            from: moment().subtract(10, 'days').format('YYYY-MM-DD'),
            to: moment().format('YYYY-MM-DD'),
        }
    };
    useEffect(() => {
        PlansService.listAsOptions().then((data) => {
            setPlans(data);
            setIsLoading(false);
        })
    }, [])
    const columns = [
        { 
            key: "id",
            label: "#"
        },
        { 
            key: "date", 
            label: t("Date"), 
            filter: DATA_TABLE_FILTER.REPORT_DATE,
            forceFilter: true,
            type: DATA_TABLE_TYPES.REPORT_DATE,
            sort: true
        },
        { 
            key: "total_count", 
            label: t("Total Transactions"), 
            render: (row) => (row.total_count),
            sort: true,
            sum: (value) => (value)
        },
        { 
            key: "success", 
            label: t("Successfull"), 
            render: (row) => (<Amount currency={row.currency} amount={parseFloat(row.success).toFixed(2)} color="success"/>),
            sort: true,
            sum: (value, lastRow) => (<Amount currency={lastRow.currency} amount={parseFloat(value).toFixed(2)} color="success"/>)
        },
        { 
            key: "pending", 
            label: t("Pending"), 
            render: (row) => (<Amount currency={row.currency} amount={parseFloat(row.pending).toFixed(2)} color="warning"/>),
            sort: true,
            sum: (value, lastRow) => (<Amount currency={lastRow.currency} amount={parseFloat(value).toFixed(2)} color="warning"/>)
        },
        { 
            key: "failed", 
            label: t("Unsuccessfull"), 
            render: (row) => (<Amount currency={row.currency} amount={parseFloat(row.failed).toFixed(2)} color="danger"/>),
            sort: true,
            sum: (value, lastRow) => (<Amount currency={lastRow.currency} amount={parseFloat(value).toFixed(2)} color="danger"/>)
        },
        { 
            key: "declined", 
            label: t("Declined"), 
            render: (row) => (<Amount currency={row.currency} amount={parseFloat(row.declined).toFixed(2)} color="danger"/>),
            sort: true,
            sum: (value, lastRow) => (<Amount currency={lastRow.currency} amount={parseFloat(value).toFixed(2)} color="danger"/>)
        },
        { 
            key: "total", 
            label: t("Total"), 
            render: (row) => (<Amount currency={row.currency} amount={parseFloat(row.total).toFixed(2)} bold={true}/>),
            sort: true,
            sum: (value, lastRow) => (<Amount currency={lastRow.currency} amount={parseFloat(value).toFixed(2)}/>)
        }
        
    ]
    useEffect(() => { 
        setPageTitle(t("Yearly and monthly payments"));
    }, [setPageTitle]);
    return (
        <>
            {isLoading?(
                <DataLoading small={true} />
            ):(
                <DataTable 
                    columns={columns} 
                    fetcher={ReportsService.payments}
                    searchPlaceholder={t("Search by Account Number or Customer Name or E-Mail...")}
                    defaultPageSize={31}
                    defaultSortKey={"date"}
                    customFilters={[{
                        key: "uid", 
                        label: t("Account Number"), 
                        filter: DATA_TABLE_FILTER.INPUT,
                    }, { 
                        key: "plan_id", 
                        label: t("Plan"),
                        filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
                        options: plans
                    }]}
                    defaultFilterConfig={defaultFilterConfig}
                />
            )}
            
        </>
    )
}
export default PaymentStats;